import { gql } from '@apollo/client';

export const DOCUMENT_TYPE_PROPERTY_REMOVED = gql`
  subscription documentTypePropertyRemoved {
    documentTypePropertyRemoved {
      documentTypeId
      propertyId
    }
  }
`;
